<app-modal-base [title]="dialogTitle" (onSubmitEvent)="onSubmit()">
  <ng-container main *ngTemplateOutlet="content"></ng-container>
</app-modal-base>


<ng-template #content>
  <div mat-dialog-content>
    <div class="formContainer d-flex justify-content-center">
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form-group row">
          <mat-form-field class="">
            <mat-label>Nouvelle position</mat-label>
            <input matInput placeholder="" type="number" required formControlName="order" />
            <mat-error>
              <span *ngIf="form_order.hasError('required')">Veuillez saisir une position valide</span>
              <span *ngIf="form_order.hasError('min')">La position doit être supérieure à 0</span>
            </mat-error>
          </mat-form-field>
        </div>
      </form>
    </div>
  </div>
</ng-template>